/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Agent_Run_Action_FailedInputs */



/**
* | output |
* | --- |
* | "{action}: failed" |
*
* @param {Agent_Run_Action_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_action_failed = /** @type {((inputs: Agent_Run_Action_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Action_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.action}: fehlgeschlagen`)
	return /** @type {LocalizedString} */ (`${i?.action}: failed`)
});